import React from "react";
import { faqs } from "../data/faqs";
export function FaqSection() {
  return <section className="section" id="faq" aria-labelledby="faq-heading" data-id="element-34" data-mp="1pk1tikdhvtcr">
      <div className="shell faq-shell" data-id="element-35" data-mp="1pi77f2qhlv73">
        <div className="section-intro" data-id="element-36" data-mp="1bl27lkhd9ska">
          <p className="eyebrow" data-id="element-37" data-mp="1bmd7vablsi6n">QUESTIONS</p>
          <h2 id="faq-heading" data-id="element-38" data-mp="1gjbyhiw26703">
            Before you <span data-id="element-39" data-mp="1gk5aay9vjmp3">get the kit</span>
          </h2>
        </div>
        <div className="fit-note" data-id="element-40" data-mp="248o98n71an4i">
          <strong data-id="element-41" data-mp="249pwdq1br02l">Built for sales team leaders and small service-business owners coaching 3–12 sellers.</strong>
          <p data-id="element-42" data-mp="289zxope692b4">
            It's for practicing customer sales conversations — not manager leadership training or
            customer-service complaint handling.
          </p>
        </div>
        <div className="faq-list" data-id="element-43" data-mp="1zgwrn25uvrqi">
          {faqs.map(faq => <details key={faq.id} id={faq.id} data-id="element-44" data-mp="2n7sc1e7zfknq">
              <summary data-id="element-45" data-mp="2n5z6y3d0p8hu">
                {faq.question}
                <span aria-hidden="true" data-id="element-46" data-mp="2rzty1ruycpqy">+</span>
              </summary>
              <p data-id="element-47" data-mp="14v0suu60nq66">{faq.answer}</p>
            </details>)}
        </div>
      </div>
    </section>;
}